import { useState } from "react";
import { Info } from "lucide-react";

/**
 * Tiny info tooltip — clickable on touch, hover on desktop.
 * Used to surface short definitions of strategic-analysis concepts.
 *
 * Usage:
 *   <InfoTip label="sofisticación estratégica" tip="Nivel de elaboración..." />
 */
export default function InfoTip({ label, tip, testid }) {
  const [open, setOpen] = useState(false);
  return (
    <span className="inline-flex items-center gap-1 relative">
      {label}
      <button
        type="button"
        data-testid={testid || "info-tip"}
        aria-label={`info ${label}`}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        className="inline-flex w-3.5 h-3.5 items-center justify-center text-[#A3A3A3] hover:text-[#D90429] transition-colors"
      >
        <Info className="w-3 h-3" />
      </button>
      {open && (
        <span
          role="tooltip"
          className="absolute top-full left-0 mt-1 z-30 w-64 bg-[#0A0A0A] text-white font-sans-body text-xs leading-snug normal-case tracking-normal p-3 border border-[#D90429] shadow-lg"
        >
          {tip}
        </span>
      )}
    </span>
  );
}
